import { Box, styled } from '@mui/material';

export const FiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));

export const SearchFieldBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(50)
}));

export const ValidityFieldBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(25)
}));
